module.exports = __webpack_public_path__ + "img/87.e67826a9.png";